export default __webpack_public_path__ + "static/media/Breast-Chest.113d2063.png";